import YFormPostTagPicker from './PostTagPicker';

export { YFormPostTagPicker };
export default YFormPostTagPicker;
